export default {
    url: process.env.VUE_APP_SSO_URL || 'https://sso.adventa.solutions/auth/',
    realm: process.env.VUE_APP_SSO_REALM || 'Adventa', 
    clientId: process.env.VUE_APP_SSO_CLIENT_ID || 'admin-catalogos-joy', 
    onLoad:'check-sso',
    silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
}